import { Controller } from 'stimulus';

export default class EzController extends Controller {
  flagLoaded() {
    this.element.setAttribute('data-loaded', 'true');
  }

  get csrfToken() {
    return document.querySelector('meta[name=csrf-token]') ? document.querySelector('meta[name=csrf-token]').content : null;
  }
}
